var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.857,
    height: 35.286,
    viewBox: "0 0 40.857 35.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -34.909)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M116.364,348.6H138.65l-11.143-11.143Z",
    transform: "translate(-107.078 -313.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.143,34.909H3.714A3.725,3.725,0,0,0,0,38.623V60.909a3.725,3.725,0,0,0,3.714,3.714h7.429V60.909H3.714V38.623H37.143V60.909H29.714v3.714h7.429a3.725,3.725,0,0,0,3.714-3.714V38.623A3.725,3.725,0,0,0,37.143,34.909Z",
    transform: "translate(0 -34.909)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.952bca1fa4c2a1b58dde1e74fb348331.svg";
export { ForwardRef as ReactComponent };